import logoWhite from "../../assets/logo-white.png";

import styles from "./Footer.module.css";

function Footer() {
	return (
		<footer className={styles.footer}>
			<img
				src={logoWhite}
				className={styles.logo}
				alt="Link"
			/>
		</footer>
	);
}

export default Footer;
